﻿namespace WebPortal.Misc {
    let OpenedWindows = new Array<Window>();

    export function openWindow(Param: string): void {
        setTimeout(() => { WindowOpenTimer(Param); }, 500);
    }
    function WindowOpenTimer(Param: string): void {
        let NewWindow: Window = window.open(Param, "_blank");
        NewWindow.status = PortalIdentifier;
        OpenedWindows.push(NewWindow);
    }

    export function getOpenWindows(): Array<Window> {
        return OpenedWindows;
    }

    /**
     * Gets the searched URL Parameter value
     * @param {string} sParam - Looks for the specified parameter
     * @param {string} sSource - Source string where the specified parameter should be looking for. Default: window.location.search.
     * @return {string} sValue
     */
    export function getUrlParameter(sParam: string, sSource?: string): any {
        let sUrl: string = sSource ? decodeURIComponent(sSource).split('?')[1] : window.location.search.substring(1);
        let sURLVariables: string[] = sUrl.split("&");

        for (let i: number = 0; i < sURLVariables.length; i++) {
            let sParameterName: string[] = sURLVariables[i].split("=");

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    }

    /**
     * Converts an object to a query string
     * @param {object} obj
     * @return {string} sValue
     */
    export function objToQueryStr(obj: any): string {
        let str: any = [];
        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                str.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
            }
        }
        return str.join("&");
    }

    /**
     * add spaces to every 3 chars. Used for displaying IDs.
     * @param {number} nValue
     * @return {string} sValue
     */
    export function addSpacesToEvery3Chars(nValue: number): string {
        let str: string = nValue.toString();
        return str.replace(/(.{3})/g, "$1 ").trim();
    }

    /**
     * remove spaces in string value. Used for selecting IDs.
     * @param {number} nValue
     * @return {string} sValue
     */
    export function removeSpacesInStr(nValue: number): string {
        let str: string = nValue.toString();
        return str.replace(/(\s)/g, "");
    }

    /**
     * Checks if the value string is a number.
     * @param {string} sValue
     * @return {boolean} bValue
     */
    export function regNumberOnlyCheck(sValue: string): boolean {
        let reg: RegExp = new RegExp("^\\d+$");
        return reg.test(sValue);
    }

    /**
     * Checks if the value string has a conform URL and if following parameters are present: id and token whereas their values contains exactly 9 characters
     * @param sValue
     */
    export function regJoinLinkCheck(sValue: string): boolean {
        let reg: RegExp = new RegExp("(http[s]?:\/\/)?([^:\/\s]+)(:([^\/]*))?(\/\w+\.)*([^#?\s]+)[(\?|\&)]([id=]+)\=([0-9]{9})[(\?|\&)]([token=]+)\=([a-fA-F0-9]{9})");
        return reg.test(sValue);
    }

    /**
     * Replaces Single Backslashes with double Backslashes
     * @param {string} sValue
     * @return {string} sValue
     */
    export function replaceBackslashesWithDoubleBackslashes(sValue: string): string {
        return sValue.replace(/\\/g, "\\\\");
    }

    export function isUndefined(obj: any, field: any): boolean {
        if (typeof obj === "undefined") {
            return true;
        }

        if (typeof obj[field] === "undefined") {
            return true;
        }

        return false;
    }

    /**
     * Generates a new GUID
     * @return {string} guidResponse
     */
    export function newGUID(): string {
        let guidHolder: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
        let hex: string = "0123456789abcdef";
        let r: number = 0;
        let guidResponse: string = "";
        for (let i: number = 0; i < 36; i++) {
            if (guidHolder[i] !== "-" && guidHolder[i] !== "4") {
                r = Math.random() * 16 | 0;
            };

            if (guidHolder[i] === "x") {
                guidResponse += hex[r];
            } else if (guidHolder[i] === "y") {
                r &= 0x3;
                r |= 0x8;
                guidResponse += hex[r];
            } else {
                guidResponse += guidHolder[i];
            };
        };
        return guidResponse;
    }

    /**
     * Format File Size
     * @param {string} _Bytes
     * @return {string}
     */
    export function formatFileSize(_Bytes: any): string {
        if (typeof _Bytes !== "number") {
            return "";
        };
        if (_Bytes >= 1000000000) {
            return (_Bytes / 1000000000).toFixed(2) + " GB";
        };
        if (_Bytes >= 1000000) {
            return (_Bytes / 1000000).toFixed(2) + " MB";
        };
        return (_Bytes / 1000).toFixed(2) + " KB";
    }

    export function showModalMessage(messageObj: any): void {
        createModal(messageObj);

        // display the modal
        $("#modal_rdp_status_messages").modal({ backdrop: "static", keyboard: false });

        function createModal(messageObj: any): void {
            let obj: any = (typeof messageObj === "string") ? { msg: messageObj, title: "", count: 1 } : messageObj;

            // contents
            if (!isUndefined(obj, "title")) {
                $("#modal_rdp_status_message_title").text(obj.title);
            }

            if (!isUndefined(obj, "msg")) {
                $("#modal_rdp_status_message_body").html(obj.msg);
            }

            if (!isUndefined(obj, "cbYes") && !isUndefined(obj, "cbNo")) {
                $("#modal_rdp_status_message_footer_close").hide();
                $("#modal_rdp_status_message_footer_yes").off().on("click", obj.cbYes).show();
                $("#modal_rdp_status_message_footer_no").off().on("click", obj.cbNo).show();
            } else {
                $("#modal_rdp_status_message_footer_yes").off().hide();
                $("#modal_rdp_status_message_footer_no").off().hide();

                if (!isUndefined(obj, "cbOk")) {
                    $("#modal_rdp_status_message_footer_close").off().on("click", obj.cbOk).show();
                } else {
                    $("#modal_rdp_status_message_footer_close").show();
                }
            }
        }
    }

    /**
     * Override Session (SparkView) notifications into navigationMessage.show() messages
     */
    export function overrideSessionNotifications(): void {
        /**
         * Overrides all notifications of hi5.notifications into a Bootstrap design.
         */
        if (hi5) {
            hi5.init.start();
            hi5.notifications.notify = function (messageData: any): void {
                if (navigationUtils.getButton("SessionInformation").length) {
                    navigationMessage.show("SessionInformation", messageData);
                } else if (navigationUtils.getButton("SessionSharing").length) {
                    navigationMessage.show("SessionSharing", messageData);
                } else {
                    navigationMessage.show("Notification", messageData);
                }
            };
        }
    }

    /**
     * Get User Agent Information. If hi5 is defined, it extracts the information. Otherwise, it only returns the userAgent string.
     */
    export function getUserAgent(): string {
        if (typeof hi5 == 'undefined')
            return navigator.userAgent;

        let str = "Browser: ";
        if (hi5.browser.isEdge) str += 'Edge';
        if (hi5.browser.isFirefox) str += 'Firefox'
        if (hi5.browser.isOpera) str += 'Opera'
        if (hi5.browser.isRIM) str += 'RIM'
        if (hi5.browser.isChrome) str += 'Chrome'
        if (isRmsClient()) str += ', RemasClient'
        if (hi5.browser.isIE) str += 'IE'
        str += ', OS: ';
        if (hi5.browser.isMacOS) str += 'MacOS'
        if (hi5.browser.isWindows) str += 'Windows'
        if (hi5.browser.isLinux) str += 'Linux'
        str += ', Additional: ';
        if (hi5.browser.isTouch) str += 'Touch Device, '
        if (hi5.browser.isAndroid) str += 'Android, '
        if (hi5.browser.isChromeApp) str += 'ChromeApp, '
        if (hi5.browser.isMultitask) str += 'Multitask'

        return str;
    }

    export function isRmsClient(): boolean {
        return navigator.userAgent.indexOf('RMS') > -1
            || navigator.userAgent.indexOf('Client') > -1
            || navigator.userAgent.indexOf('Electron') > -1;
    }

    /**
    * Detect Internet Explorer
    * @return {boolean}
    */
    export function isInternetExplorerDetected(): boolean {
        let isIE: boolean = false;

        if (navigator.appName == 'Microsoft Internet Explorer') {
            let ua = navigator.userAgent,
                re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})");

            if (re.exec(ua) !== null) {
                return true;
            }
        }
        else if (navigator.appName == "Netscape") {
            /// in IE 11 the navigator.appVersion says 'trident'
            /// in Edge the navigator.appVersion does not say trident
            if (navigator.appVersion.indexOf('Trident') > 1)
                return true;
        }

        return false;
    }

    export function ShowTenantSelection(_Request: string, _TenantList: any, _LoginTenantId: number, _LanguageId: number): void {
        tempRequest = _Request;
        $("#pn_login").addClass("hidden");
        $("#pn_MobileID").addClass("hidden");
        $("#pn_WebToken").addClass("hidden");
        $("#pn_SMSTan").addClass("hidden");
        $("#pn_Oidb").addClass("hidden");
        $("#email").blur();
        $("#password").blur();

        $("#pn_TenantSelection").removeClass("hidden");

        for (let entry of _TenantList) {
            $("#select_TenantSelection").append(new Option(entry.value, entry.key, false, false));
        }

        $('#select_TenantSelection option').sort(function (a, b) {
            return a.textContent.localeCompare(b.textContent);
        }).appendTo("#select_TenantSelection");

        loginTenantId = _LoginTenantId;
        if (loginTenantId != 1) {
            $("#select_TenantSelection").selectpicker("val", loginTenantId);
        }

        // Tenant Info anzeigen
        switch (_LanguageId) {
            // Deutsch
            case 2:
                $("#pn_TenantSelection_info_german").removeClass("hidden");
                break;
            // Französisch
            case 3:
                $("#pn_TenantSelection_info_french").removeClass("hidden");
                break;
            // Italienisch
            case 5:
                $("#pn_TenantSelection_info_italian").removeClass("hidden");
                break;
            // alle anderen Englisch
            default:
                $("#pn_TenantSelection_info_english").removeClass("hidden");
        }

        $("#select_TenantSelection").selectpicker('refresh');
        $("#bt_TenantSelection_log_in").focus();
    }
}